import { BRAND, NAV_LINKS } from '../data/content';

const Footer = () => (
    <footer data-testid="site-footer" className="bg-[#0A0A0B] text-white pt-20 pb-10 border-t border-white/10">
        <div className="mx-auto max-w-[1500px] px-6 md:px-10">
            <div className="grid grid-cols-12 gap-8 pb-14 border-b border-white/10">
                <div className="col-span-12 md:col-span-6">
                    <div className="h-display text-4xl md:text-6xl leading-none">
                        Indian<br />
                        Industrial<br />
                        Distributors<span className="text-[#FF3B00]">.</span>
                    </div>
                    <div className="overline text-white/50 mt-6">{BRAND.tagline}</div>
                </div>
                <div className="col-span-6 md:col-span-3">
                    <div className="overline text-white/40 mb-4">Navigate</div>
                    <ul className="space-y-2 text-sm">
                        {NAV_LINKS.map((l) => (
                            <li key={l.id}>
                                <a href={l.href} data-testid={`footer-${l.id}`} className="hover:text-[#FF3B00] transition-colors">{l.label}</a>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="col-span-6 md:col-span-3">
                    <div className="overline text-white/40 mb-4">Reach</div>
                    <div className="text-sm space-y-2 font-mono">
                        {BRAND.phones.map((p) => <div key={p}>{p}</div>)}
                        {BRAND.emails.map((e) => <div key={e} className="text-white/80">{e}</div>)}
                    </div>
                </div>
            </div>
            <div className="pt-8 flex flex-col md:flex-row justify-between gap-4 overline text-white/40">
                <div>© {new Date().getFullYear()} Indian Industrial Distributors · Thane · Maharashtra</div>
                <div>Built with precision · Est. 1985</div>
            </div>
        </div>
    </footer>
);

export default Footer;
